import { useFormikContext } from 'formik'
import { Button } from 'blaze-ui/Button'
import { useSections } from 'components/Wizards/Wizard/Form/Sections/SectionsProvider'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'

export const ResetFormButton = () => {
  const { mainFields } = useSections()
  const { setStatus, setFieldValue, initialValues } = useFormikContext<{ [key: string]: any }>()

  const handlePress = () => {
    setStatus(FormStatus.ManuallyFilled)
    mainFields.forEach(([field]) => {
      setFieldValue(field, initialValues[field])
    })
  }

  return (
    <Button onPress={handlePress} size="md" variant="tertiary">
      Reset auto filled inputs
    </Button>
  )
}
